import { render, staticRenderFns } from "./DepartmentDeleteButton.vue?vue&type=template&id=5249b2cc&scoped=true&"
import script from "./DepartmentDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DepartmentDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentDeleteButton.vue?vue&type=style&index=0&id=5249b2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249b2cc",
  null
  
)

export default component.exports